import { imagePrefix } from 'utils/helpers/images';

const baseMusicRubricsInfo = [
	{
		description:
			'Читать статьи об известных филармониях, концертных площадках, о выступлениях музыкантов, о жизни композиторов и исполнителей.',
		defaultImage: `${imagePrefix}images/catalogs/music-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/music/articles'
	},
	{
		description:
			'Какой послушать концерт? Подборки концертов — из филармонии, оперы, конкурсные выступления, песни на различные темы.',
		defaultImage: `${imagePrefix}images/catalogs/music-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/music/themes'
	},
	{
		description:
			'Лучшие концертные площадки России, концертные залы и филармонии. Современные концертные площадки России: фото, адреса на карте, описания на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/music-concertVenues.jpg`,
		title: 'Концертные площадки',
		type: 'concertVenues',
		url: '/music/concert-venues'
	},
	{
		description:
			'Смотреть и слушать концерты онлайн. Информация об исполнителе и оркестре.',
		defaultImage: `${imagePrefix}images/catalogs/music-concerts.jpg`,
		title: 'Концерты',
		type: 'concerts',
		url: '/music/concerts'
	},
	{
		description:
			'Самые известные музыкальные коллективы: фотографии, история и участники.',
		defaultImage: `${imagePrefix}images/catalogs/music-musicalGroups.jpg`,
		title: 'Музыкальные коллективы',
		type: 'musicalGroups',
		url: '/music/musical-groups'
	},
	{
		description:
			'Полные биографии великих музыкантов России. Личная жизнь, интересные факты из жизни на Портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/music-persons.jpg`,
		title: 'Биографии',
		type: 'persons',
		url: '/music/persons'
	}
];

const baseCinemaRubricsInfo = [
	{
		description:
			'Читать статьи об известных фильмах, интервью актеров, режиссеров и других деятелей кинематографа, о том, как снимается кино и как оно зарождалось.',
		defaultImage: `${imagePrefix}images/catalogs/cinema-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/cinema/articles'
	},
	{
		description:
			'Подборки фильмов: комедии, боевики, подборки фильмов Тарковского, фильмов с Вициным и другие.',
		defaultImage: `${imagePrefix}images/catalogs/cinema-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/cinema/themes'
	},
	{
		description:
			'Каталог советских, русских и зарубежных фильмов, художественные, документальные фильмы, боевики, комедии, драмы — смотреть онлайн и бесплатно. Лучшие классические и редкие фильмы на портале «Культура.РФ».',
		defaultImage: `${imagePrefix}images/catalogs/cinema-movies.jpg`,
		title: 'Фильмы онлайн',
		type: 'movies',
		url: '/cinema/movies'
	},

	{
		description:
			'Читать о деятелях культуры, фотографии, творчество, личная жизнь. Интервью с известными актерами и режиссерами.',
		defaultImage: `${imagePrefix}images/catalogs/cinema-persons.jpg`,
		title: 'Биографии',
		type: 'persons',
		url: '/cinema/persons'
	}
];

const baseMuseumsRubricsInfo = [
	{
		description:
			'Интересные факты, полезная информация и статьи о музеях России на сайте Культура.РФ.',
		defaultImage: `${imagePrefix}images/catalogs/institutes-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/museums/articles'
	},
	{
		description:
			'Подборки музеев — музеи писателей, музеи-усадьбы, детские музеи, музеи под открытым небом.',
		defaultImage: `${imagePrefix}images/catalogs/institutes-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/museums/themes'
	},
	{
		description:
			'Архитектурные, исторические, художественные и другие музеи России. Описания, фотографии, виртуальные экскурсии по крупнейшим музеям.',
		defaultImage: `${imagePrefix}images/catalogs/museums-institutes.jpg`,
		title: 'Каталог музеев',
		type: 'institutes',
		url: '/museums/institutes'
	},
	{
		description:
			'Полные биографии великих художников России. Личная жизнь, картины, интересные факты из жизни художников и скульпторов на Портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/institutes-persons.jpg`,
		title: 'Биографии',
		type: 'persons',
		url: '/museums/persons'
	}
];

const baseTheatersRubricsInfo = [
	{
		description:
			'Читать статьи об известных театрах, постановках, о необычных спектаклях, о жизни актеров и театральных режиссеров.',
		defaultImage: `${imagePrefix}images/catalogs/theaters-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/theaters/articles'
	},
	{
		description:
			'Какой спектакль посмотреть? Подборки спектаклей из известных театров, спектакли на одну тему, одного режиссера и актера.',
		defaultImage: `${imagePrefix}images/catalogs/theaters-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/theaters/themes'
	},
	{
		description:
			'Описания, фотографии лучших театров России. Спектакли онлайн из драматических, музыкальных, кукольных театров, театров зверей, клоунады и других.',
		defaultImage: `${imagePrefix}images/catalogs/theaters-institutes.jpg`,
		title: 'Театры',
		type: 'institutes',
		url: '/theaters/institutes'
	},
	{
		description:
			'Смотреть лучшие спектакли онлайн бесплатно в хорошем качестве. Моноспектакли, телеспектакли, балет, оперетты, мюзиклы, аудиоспектакли и спектакли из золотого фонда СССР. Видео на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/theaters-performances.jpg`,
		title: 'Cпектакли',
		type: 'performances',
		url: '/theaters/performances'
	},
	{
		description:
			'Полные биографии советских и российских актеров, танцоров, хореографов, художественных руководителей театра. Личная жизнь, спектакли, фотографии, интересные факты из жизни актеров, танцоров, хореографов, художественных руководителей театра на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/theaters-persons.jpg`,
		title: 'Биографии',
		type: 'persons',
		url: '/theaters/persons'
	}
];

const baseLiteratureRubricsInfo = [
	{
		description:
			'Читать статьи об известных литературных произведениях, как создаются книги, о жизни писателей и поэтов.',
		defaultImage: `${imagePrefix}images/catalogs/libraries-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/literature/articles'
	},
	{
		description:
			'Что почитать? Подборки книг — на единую тематику, подборки рождественских рассказов, детских сказок, книг Булгакова и другие.',
		defaultImage: `${imagePrefix}images/catalogs/libraries-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/literature/themes'
	},
	{
		description:
			'Самые известные произведения российских классиков читать или скачать онлайн бесплатно. Список лучших художественных книг русских авторов для взрослых и детей. Библиография писателей на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/libraries-books.jpg`,
		title: 'Каталог книг онлайн',
		type: 'books',
		url: '/literature/books'
	},
	{
		description: 'Библиотеки страны: история, адреса, телефоны для связи.',
		defaultImage: `${imagePrefix}images/catalogs/literature-libraries.jpg`,
		title: 'Библиотеки',
		type: 'libraries',
		url: '/literature/libraries'
	},
	{
		description:
			'Полные биографии известных российских писателей и поэтов. Личная жизнь, интересные факты из жизни на Портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/libraries-persons.jpg`,
		title: 'Биографии',
		type: 'persons',
		url: '/literature/persons'
	}
];

const baseTraditionsRubricsInfo = [
	{
		description:
			'Интересные факты, полезная информация и статьи о традициях России на сайте Культура.РФ.',
		defaultImage: `${imagePrefix}images/catalogs/traditions-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/traditions/articles'
	},
	{
		description:
			'Как отмечали праздники и во что верили наши предки? Подборка обычаев и традиций — празднование Пасхи, шаманские обряды и другие.',
		defaultImage: `${imagePrefix}images/catalogs/traditions-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/traditions/themes'
	},
	{
		description:
			'Нематериальное культурное наследие России на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/traditions-cultureHeritageObjects.jpg`,
		title: 'Нематериальное наследие',
		type: 'cultureHeritageObjects',
		url: '/traditions/culture-heritage'
	},
	{
		description:
			'Религиозное наследие России, места, в которых нужно обязательно побывать. Религиозное наследие России: фото, адреса на карте, описания на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/traditions-religionHeritageObjects.jpg`,
		title: 'Религиозное наследие',
		type: 'religionHeritageObjects',
		url: '/traditions/religion-heritage'
	},
	{
		description:
			'Читать о памятниках культуры за границей, связанных с Россией. Фотографии, исторические справки.',
		defaultImage: `${imagePrefix}images/catalogs/traditions-foreignHeritageObjects.jpg`,
		title: 'Зарубежное наследие',
		type: 'foreignHeritageObjects',
		url: '/traditions/foreign-heritage'
	},
	{
		description:
			'Дворцы культуры и клубы России: подробная информация, адреса, телефоны, время работы, история, фотографии, видео на сайте Культура.РФ.',
		defaultImage: `${imagePrefix}images/catalogs/traditions-domaKulturyIKluby.jpg`,
		title: 'Дома культуры и клубы',
		type: 'domaKulturyIKluby',
		url: '/traditions/doma-kultury-i-kluby'
	}
];

const baseArchitectureRubricsInfo = [
	{
		description:
			'Читать статьи об известных известных архитектурных памятниках, о создании необычных зданий и сооружений, о жизни архитекторов.',
		defaultImage: `${imagePrefix}images/catalogs/architecture-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/architecture/articles'
	},
	{
		description:
			'Где увидеть шедевры архитектуры в России? Подборки известных зданий — знаменитые усадьбы, дома в определенном стиле.',
		defaultImage: `${imagePrefix}images/catalogs/architecture-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/architecture/themes'
	},
	{
		description:
			'Лучшие архитектурные объекты России, в которых нужно обязательно побывать. Главные архитектурные объекты России: фото, адреса на карте, описания на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/architecture-architectureInstitutes.jpg`,
		title: 'Архитектурный каталог',
		type: 'architectureInstitutes',
		url: '/architecture/institutes'
	},
	{
		description:
			'Лучшие усадьбы России, открытые для посещения. Старинные усадьбы России: фото, адреса на карте, описания на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/architecture-manors.jpg`,
		title: 'Усадьбы',
		type: 'manors',
		url: '/architecture/manors'
	},
	{
		description:
			'Узнать значение архитектурных терминов онлайн и бесплатно. Что такое балюстрада, восьмерик, изразец, наличник, пилястра и другие.',
		defaultImage: `${imagePrefix}images/catalogs/architecture-terms.jpg`,
		title: 'Термины',
		type: 'terms',
		url: '/architecture/terms'
	},
	{
		description:
			'Полные биографии известных российских архитекторов. Личная жизнь, интересные факты из жизни на Портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/architecture-persons.jpg`,
		title: 'Биографии',
		type: 'persons',
		url: '/architecture/persons'
	}
];

const baseLecturesRubricsInfo = [
	{
		description:
			'Читать статьи по русскому языку, истории, литературе. Статьи о писателях, художниках, исторических личностях.',
		defaultImage: `${imagePrefix}images/catalogs/educational-articles.jpg`,
		title: 'Статьи',
		type: 'articles',
		url: '/lectures/articles'
	},
	{
		description:
			'Как известные писатели создавали свои произведения? Подборки о жизни деятелей культуры, о создании известных картин, о мировом океане и другие.',
		defaultImage: `${imagePrefix}images/catalogs/educational-themes.jpg`,
		title: 'Тематические подборки',
		type: 'themes',
		url: '/lectures/themes'
	},
	{
		description:
			'Курсы лекций слушать бесплатно онлайн. Видео лекций в хорошем качестве без регистрации и без рекламы на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/educational-lectures.jpg`,
		title: 'Лекции онлайн',
		type: 'lectures',
		url: '/lectures/movies'
	},
	{
		description:
			'Полные биографии ученых, меценатов, общественных и военных деятелей. Личная жизнь, лекции, фотографии, интересные факты из жизни ученых, меценатов, общественных и военных деятелей на портале «Культура.РФ»',
		defaultImage: `${imagePrefix}images/catalogs/educational-persons.jpg`,
		title: 'Биографии',
		type: 'persons',
		url: '/lectures/persons'
	}
];

export const rubricPageCardsHash = {
	cinema: baseCinemaRubricsInfo,
	'tematicheskie-podborki-razdela-kino': baseCinemaRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'tematicheskie-podborki-razdela-muzei': baseMuseumsRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'tematicheskie-podborki-razdela-muzyka': baseMusicRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'tematicheskie-podborki-razdela-teatry': baseTheatersRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'tematicheskie-podborki-razdela-literatura': baseLiteratureRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'tematicheskie-podborki-razdela-tradicii': baseTraditionsRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'tematicheskie-podborki-razdela-arkhitektura': baseArchitectureRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'tematicheskie-podborki-razdela-lekcii': baseLecturesRubricsInfo.filter(
		(rubric) => rubric.type !== 'themes'
	),
	'architecture/articles': baseArchitectureRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	'cinema/articles': baseCinemaRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	'lectures/articles': baseLecturesRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	'literature/articles': baseLiteratureRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	'museums/articles': baseMuseumsRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	'music/articles': baseMusicRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	'theaters/articles': baseTheatersRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	'traditions/articles': baseTraditionsRubricsInfo.filter(
		(rubric) => rubric.type !== 'articles'
	),
	architecture: baseArchitectureRubricsInfo,
	manors: baseArchitectureRubricsInfo.filter(
		(rubric) => rubric.type !== 'manors'
	),
	educational: baseLecturesRubricsInfo,
	libraries: baseLiteratureRubricsInfo.filter(
		(rubric) => rubric.type !== 'libraries'
	),
	institutes: [
		{
			description:
				'Интересные факты, полезная информация и статьи о музеях России на сайте Культура.РФ.',
			defaultImage: `${imagePrefix}images/catalogs/institutes-articles.jpg`,
			title: 'Статьи',
			type: 'articles',
			url: '/museums/articles'
		},
		{
			description:
				'Подборки музеев — музеи писателей, музеи-усадьбы, детские музеи, музеи под открытым небом.',
			defaultImage: `${imagePrefix}images/catalogs/institutes-themes.jpg`,
			title: 'Тематические подборки',
			type: 'themes',
			url: '/museums/themes'
		},
		{
			description:
				'Полные биографии великих художников России. Личная жизнь, картины, интересные факты из жизни художников и скульпторов на Портале «Культура.РФ»',
			defaultImage: `${imagePrefix}images/catalogs/institutes-persons.jpg`,
			title: 'Биографии',
			type: 'persons',
			url: '/museums/persons'
		}
	],
	music: baseMusicRubricsInfo,
	theaters: baseTheatersRubricsInfo,
	traditions: baseTraditionsRubricsInfo.filter(
		(rubric) => rubric.type !== 'domaKulturyIKluby'
	),
	culture_heritage: baseTraditionsRubricsInfo.filter(
		(rubric) => rubric.type !== 'cultureHeritageObjects'
	),
	religion_heritage: baseTraditionsRubricsInfo.filter(
		(rubric) => rubric.type !== 'religionHeritageObjects'
	),
	foreign_heritage: baseTraditionsRubricsInfo.filter(
		(rubric) => rubric.type !== 'foreignHeritageObjects'
	),
	circuses: [
		{
			description:
				'Интересные зоопарки России для взрослых и детей. Подробная информация: описание, фотографии, животные, адреса на карте, режимы работы, интересные факты на официальном портале Культура.РФ',
			defaultImage: `${imagePrefix}images/catalogs/visit-zoos.jpg`,
			title: 'Каталог зоопарков',
			type: 'zoos',
			url: '/visit/zoos'
		},
		{
			description:
				'Знаменитые парки России. Подробная информация: описание, фотографии, адреса на карте, режимы работы, интересные факты на официальном портале Культура.РФ',
			defaultImage: `${imagePrefix}images/catalogs/visit-parks.jpg`,
			title: 'Каталог парков',
			type: 'parks',
			url: '/visit/parks'
		},
		{
			description:
				'Лучшие музеи России, в которых нужно обязательно побывать. Главные современные музеи России для взрослых и детей: фото, адреса на карте, описания на портале «Культура.РФ»',
			defaultImage: `${imagePrefix}images/catalogs/visit-virtualTourInstitutes.jpg`,
			title: 'Виртуальные туры',
			type: 'virtualTourInstitutes',
			url: '/museums/institutes/location-russia/hasVirtualTours-true'
		},
		{
			description:
				'Главные достопримечательности России! Архитектурные и природные достопримечательности страны: названия, описание, режимы работы, адреса, фото, телефоны. Музеи, памятники и другие достопримечательности',
			defaultImage: `${imagePrefix}images/catalogs/visit-russiaImages.jpg`,
			title: 'Образы России',
			type: 'russiaImages',
			url: '/russia'
		},
		{
			description:
				'Религиозное наследие России, места, в которых нужно обязательно побывать. Религиозное наследие России: фото, адреса на карте, описания на портале «Культура.РФ»',
			defaultImage: `${imagePrefix}images/catalogs/traditions-religionHeritageObjects.jpg`,
			title: 'Религиозное наследие',
			type: 'religionHeritageObjects',
			url: '/traditions/religion-heritage'
		}
	],
	parks: [
		{
			description:
				'Интересные зоопарки России для взрослых и детей. Подробная информация: описание, фотографии, животные, адреса на карте, режимы работы, интересные факты на официальном портале Культура.РФ',
			defaultImage: `${imagePrefix}images/catalogs/visit-zoos.jpg`,
			title: 'Каталог зоопарков',
			type: 'zoos',
			url: '/visit/zoos'
		},
		{
			description:
				'Знаменитые цирки России: для взрослых и детей, с животными и без животных. Подробная информация: описание, фотографии, адреса на карте, режимы работы, интересные факты на официальном портале Культура.РФ',
			defaultImage: `${imagePrefix}images/catalogs/visit-circuses.jpg`,
			title: 'Каталог цирков',
			type: 'circuses',
			url: '/visit/circuses'
		},
		{
			description:
				'Лучшие музеи России, в которых нужно обязательно побывать. Главные современные музеи России для взрослых и детей: фото, адреса на карте, описания на портале «Культура.РФ»',
			defaultImage: `${imagePrefix}images/catalogs/visit-virtualTourInstitutes.jpg`,
			title: 'Виртуальные туры',
			type: 'virtualTourInstitutes',
			url: '/museums/institutes/location-russia/hasVirtualTours-true'
		},
		{
			description:
				'Главные достопримечательности России! Архитектурные и природные достопримечательности страны: названия, описание, режимы работы, адреса, фото, телефоны. Музеи, памятники и другие достопримечательности',
			defaultImage: `${imagePrefix}images/catalogs/visit-russiaImages.jpg`,
			title: 'Образы России',
			type: 'russiaImages',
			url: '/russia'
		},
		{
			description:
				'Религиозное наследие России, места, в которых нужно обязательно побывать. Религиозное наследие России: фото, адреса на карте, описания на портале «Культура.РФ»',
			defaultImage: `${imagePrefix}images/catalogs/traditions-religionHeritageObjects.jpg`,
			title: 'Религиозное наследие',
			type: 'religionHeritageObjects',
			url: '/traditions/religion-heritage'
		}
	],
	zoos: [
		{
			description:
				'Знаменитые парки России. Подробная информация: описание, фотографии, адреса на карте, режимы работы, интересные факты на официальном портале Культура.РФ',
			defaultImage: `${imagePrefix}images/catalogs/visit-parks.jpg`,
			title: 'Каталог парков',
			type: 'parks',
			url: '/visit/parks'
		},
		{
			description:
				'Знаменитые цирки России: для взрослых и детей, с животными и без животных. Подробная информация: описание, фотографии, адреса на карте, режимы работы, интересные факты на официальном портале Культура.РФ',
			defaultImage: `${imagePrefix}images/catalogs/visit-circuses.jpg`,
			title: 'Каталог цирков',
			type: 'circuses',
			url: '/visit/circuses'
		},
		{
			description:
				'Лучшие музеи России, в которых нужно обязательно побывать. Главные современные музеи России для взрослых и детей: фото, адреса на карте, описания на портале «Культура.РФ»',
			defaultImage: `${imagePrefix}images/catalogs/visit-virtualTourInstitutes.jpg`,
			title: 'Виртуальные туры',
			type: 'virtualTourInstitutes',
			url: '/museums/institutes/location-russia/hasVirtualTours-true'
		},
		{
			description:
				'Главные достопримечательности России! Архитектурные и природные достопримечательности страны: названия, описание, режимы работы, адреса, фото, телефоны. Музеи, памятники и другие достопримечательности',
			defaultImage: `${imagePrefix}images/catalogs/visit-russiaImages.jpg`,
			title: 'Образы России',
			type: 'russiaImages',
			url: '/russia'
		},
		{
			description:
				'Религиозное наследие России, места, в которых нужно обязательно побывать. Религиозное наследие России: фото, адреса на карте, описания на портале «Культура.РФ»',
			defaultImage: `${imagePrefix}images/catalogs/traditions-religionHeritageObjects.jpg`,
			title: 'Религиозное наследие',
			type: 'religionHeritageObjects',
			url: '/traditions/religion-heritage'
		}
	],
	musical_groups: baseMusicRubricsInfo.filter(
		(rubric) => rubric.type !== 'musicalGroups'
	)
};
